export enum Language {
	English = 'en',
	Serbian = 'sr',
}

export const DEFAULT_LANGUAGE = Language.Serbian;
